export const articles = [
  {
    slug: 'plot-full-summary',
    title: '继母的朋友们漫画完整剧情梳理：从开篇到最新话全解析',
    excerpt: '继母的朋友们漫画以其细腻的情感描写和引人入胜的剧情发展，成为近年来最受关注的韩漫之一。本文将从第一话开始，为你完整梳理整个故事的发展脉络与关键转折点。',
    content: `<p>《继母的朋友们》是韩国漫画家创作的一部备受瞩目的网络漫画作品。故事围绕着主角与继母的朋友们之间展开的一系列复杂而微妙的情感纠葛，以其细腻的人物刻画和出人意料的剧情转折赢得了大量读者的喜爱。</p>
<h3>故事开篇</h3>
<p>故事的开端设定在一个平凡的家庭环境中。主角原本过着普通的生活，但随着继母的出现，一切都开始发生变化。继母带来了她的社交圈——一群性格迥异、各具魅力的朋友们。这些新角色的加入，让原本平静的生活掀起了波澜。</p>
<h3>剧情发展</h3>
<p>随着剧情的推进，主角与继母的朋友们之间产生了各种交集。每一个朋友都有自己独特的故事线和性格特点。作者通过巧妙的情节安排，让每一条线索都交织在一起，形成了一个庞大而精密的故事网络。</p>
<p>在中期剧情中，感情线逐渐明朗化。主角面临着多重选择，每一个选择都可能导向完全不同的结局。这种不确定性让读者保持着高度的阅读期待。</p>
<h3>关键转折</h3>
<p>故事中的几个关键转折点尤其精彩。当某些隐藏的秘密被揭开时，整个故事的走向发生了戏剧性的变化。这些转折不仅推动了剧情发展，也深化了人物形象。</p>
<h3>最新进展</h3>
<p>截至目前的最新章节，故事已经进入了一个新的阶段。角色之间的关系更加复杂，新的冲突正在酝酿之中。读者们都在期待着作者接下来的精彩安排。</p>`,
    category: 'plot',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20reading%20corner%20with%20an%20open%20graphic%20novel%20on%20a%20wooden%20table%2C%20soft%20golden%20hour%20light%20streaming%20through%20curtains%2C%20cozy%20interior%2C%20artistic%20storytelling%20vibe%2C%20warm%20amber%20tones%2C%20editorial%20photography&width=1200&height=675&seq=article-plot-01&orientation=landscape',
    readTime: '15分钟',
    publishDate: '2026-08-05',
    tags: ['剧情梳理', '完整解析', '韩漫推荐'],
  },
  {
    slug: 'main-character-analysis',
    title: '继母的朋友们漫画主角深度解析：性格、动机与成长弧光',
    excerpt: '主角作为继母的朋友们漫画的核心人物，其复杂的性格设定和成长轨迹是整部作品最吸引人的部分。让我们深入分析这个角色的多面性。',
    content: `<p>在《继母的朋友们》这部作品中，主角的塑造堪称精妙。他并非传统意义上的完美主角，而是充满了人性的弱点和矛盾，正是这种真实感让他赢得了读者的共鸣。</p>
<h3>性格特征</h3>
<p>主角的性格中包含了善良、犹豫、勇敢和脆弱等多个层面。在面对继母的朋友们时，他展现出的态度和反应都极其真实——有时果断，有时迷茫。这种复杂性使得角色立体而富有魅力。</p>
<h3>动机分析</h3>
<p>驱动主角行动的核心动机是什么？从表面看是对人际关系的探索，但更深层次上，是对于自我认同和归属感的追寻。这种内在驱动力让他的每一个决定都有据可循。</p>
<h3>成长轨迹</h3>
<p>从故事开始到现在，主角经历了显著的成长。他学会了更好地处理复杂的人际关系，也对自己有了更清晰的认识。这种成长的弧光让整部作品具备了更深层次的价值。</p>`,
    category: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20character%20concept%20illustration%20sketchbook%20open%20on%20a%20minimalist%20desk%2C%20soft%20warm%20lighting%2C%20creative%20studio%20atmosphere%2C%20character%20design%20exploration%2C%20artistic%20workspace%2C%20warm%20neutral%20tones&width=1200&height=675&seq=article-char-01&orientation=landscape',
    readTime: '12分钟',
    publishDate: '2026-08-03',
    tags: ['角色解析', '主角分析', '人物成长'],
  },
  {
    slug: 'supporting-characters-guide',
    title: '继母的朋友们漫画配角群像：每个角色背后的故事',
    excerpt: '除了主角之外，继母的朋友们漫画中的配角同样精彩纷呈。每一个配角都有独立的背景故事和鲜明的性格特征，共同构筑了这个丰富的故事世界。',
    content: `<p>《继母的朋友们》最令人称道的地方之一，就是对配角的精心塑造。没有一个角色是纯粹的工具人，每个人都有自己的故事和动机。</p>
<h3>继母的角色定位</h3>
<p>继母在故事中扮演着至关重要的角色。她不仅仅是一个功能性角色，而是有着自己复杂情感和过去的关键人物。她的出现改变了整个家庭的动态平衡。</p>
<h3>朋友们的群像</h3>
<p>继母的朋友们各具特色：有的温柔体贴，有的大胆直率，有的神秘莫测。作者为每一个角色都设计了独特的性格标签和故事线，让读者能够在不同角色身上找到共鸣。</p>
<h3>角色关系网络</h3>
<p>这些角色之间的关系错综复杂，形成了一个精密的关系网络。友情、爱情、竞争、合作——各种关系类型交织其中，让故事充满了戏剧性和可看性。</p>`,
    category: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Group%20of%20diverse%20character%20silhouettes%20in%20a%20warm%20atmospheric%20setting%2C%20artistic%20illustration%20style%2C%20soft%20golden%20lighting%2C%20community%20and%20connection%20theme%2C%20warm%20amber%20and%20cream%20tones&width=1200&height=675&seq=article-char-02&orientation=landscape',
    readTime: '10分钟',
    publishDate: '2026-07-30',
    tags: ['配角群像', '角色关系', '人物设定'],
  },
  {
    slug: 'latest-chapter-update',
    title: '继母的朋友们漫画最新话更新：第128话剧情速报',
    excerpt: '继母的朋友们漫画第128话已于本周更新！本话剧情迎来重大转折，几位主要角色之间的关系发生了微妙变化。立即了解最新内容。',
    content: `<p>《继母的朋友们》第128话如约更新，本话的剧情可谓精彩纷呈，多个伏笔同时回收，让读者大呼过瘾。</p>
<h3>本话要点</h3>
<p>这一话重点推进了主线剧情，一个长期埋藏的悬念终于得到了解答。同时，某个配角的过去也被进一步揭示，让读者对这个角色有了全新的认识。</p>
<h3>关键场景</h3>
<p>本话中有几个场景尤其值得关注。其中一段对话场景的处理极为细腻，通过微妙的表情变化和肢体语言，传达出了丰富的情感信息。</p>
<h3>剧情展望</h3>
<p>从本话结尾的暗示来看，接下来的剧情将会更加精彩。新的冲突正在酝酿之中，几位主要角色都将面临重要的选择。</p>`,
    category: 'updates',
    coverImage: 'https://readdy.ai/api/search-image?query=Freshly%20printed%20comic%20pages%20spread%20on%20a%20warm%20wooden%20surface%20with%20morning%20light%2C%20new%20release%20excitement%2C%20artistic%20composition%2C%20warm%20natural%20lighting%2C%20editorial%20photography%20style&width=1200&height=675&seq=article-upd-01&orientation=landscape',
    readTime: '8分钟',
    publishDate: '2026-08-07',
    tags: ['最新更新', '第128话', '剧情速报'],
  },
  {
    slug: 'update-schedule-2026',
    title: '继母的朋友们漫画2026年更新日程表与连载状态',
    excerpt: '想了解继母的朋友们漫画的更新频率和连载计划？本文为你整理了2026年的完整更新日程，包括预计完结时间和休刊安排。',
    content: `<p>对于追更读者来说，了解作品的更新规律至关重要。《继母的朋友们》目前的连载状态相对稳定，以下是详细的更新信息。</p>
<h3>更新频率</h3>
<p>目前《继母的朋友们》保持每周一更的节奏，通常在每周五更新新章节。偶尔会因为作者身体状况或节假日调整更新时间，但总体上非常规律。</p>
<h3>连载平台</h3>
<p>本作在多个主流漫画平台同步连载，读者可以选择自己喜欢的平台进行阅读。各平台的更新时间略有差异，但通常在24小时内都会同步。</p>
<h3>完结预测</h3>
<p>根据目前的故事进展和作者透露的信息，预计本作将在2027年上半年完结。不过这只是预测，具体还要看作者的创作节奏。</p>`,
    category: 'updates',
    coverImage: 'https://readdy.ai/api/search-image?query=Calendar%20and%20schedule%20planner%20on%20a%20warm%20minimalist%20desk%2C%20organized%20creative%20workspace%2C%20soft%20natural%20lighting%2C%20planning%20and%20productivity%20aesthetic%2C%20warm%20neutral%20color%20palette&width=1200&height=675&seq=article-upd-02&orientation=landscape',
    readTime: '6分钟',
    publishDate: '2026-07-28',
    tags: ['更新日程', '连载状态', '追更指南'],
  },
  {
    slug: 'reader-review-roundup',
    title: '继母的朋友们漫画全网评价汇总：读者真实口碑大公开',
    excerpt: '继母的朋友们漫画在各平台的评价如何？本文收集了来自多个社区的读者真实评价，为你呈现这部作品的全网口碑情况。',
    content: `<p>《继母的朋友们》自连载以来，在各漫画平台和社交社区都积累了大量的读者评价。总体来说，这部作品的口碑呈现出明显的两极分化趋势。</p>
<h3>好评聚焦</h3>
<p>多数好评集中在作品的画风和情感描写上。读者们普遍认可作者细腻的笔触和对人物心理的精准把握。尤其是在关键情感场景的处理上，获得了广泛好评。</p>
<h3>争议之声</h3>
<p>也有部分读者对作品的剧情节奏和部分角色设定提出了质疑。有人认为中期节奏偏慢，也有人对某些情节走向表示不满。这些争议恰恰说明了作品的话题性和讨论度。</p>
<h3>综合评分</h3>
<p>在主要漫画平台上，本作的综合评分稳定在4.2/5左右。考虑到其庞大的读者基数，这个分数相当不错，证明了作品的整体质量。</p>`,
    category: 'reviews',
    coverImage: 'https://readdy.ai/api/search-image?query=Community%20discussion%20board%20with%20warm%20cafe%20atmosphere%2C%20people%20sharing%20opinions%2C%20soft%20ambient%20lighting%2C%20social%20gathering%20concept%2C%20warm%20and%20inviting%20interior%2C%20lifestyle%20photography&width=1200&height=675&seq=article-rev-01&orientation=landscape',
    readTime: '9分钟',
    publishDate: '2026-08-01',
    tags: ['读者评价', '口碑汇总', '评分分析'],
  },
  {
    slug: 'reading-platform-guide',
    title: '继母的朋友们漫画在线阅读平台推荐与使用指南',
    excerpt: '不知道在哪里看继母的朋友们漫画？本文为你整理了最优质的在线阅读平台，包括免费和付费选项，助你找到最佳阅读体验。',
    content: `<p>对于想要开始阅读或追更《继母的朋友们》的朋友来说，选择一个合适的阅读平台非常重要。不同的平台提供不同的阅读体验和服务。</p>
<h3>主流平台对比</h3>
<p>目前提供《继母的朋友们》在线阅读的平台主要有几个：KakaoPage、Naver Webtoon、以及一些中文漫画平台。每个平台都有自己的特点和优势。</p>
<h3>免费 vs 付费</h3>
<p>部分平台提供一定数量的免费章节，适合想要试读的新读者。对于追更读者来说，付费订阅通常能获得更好的阅读体验和更及时的更新。</p>
<h3>阅读建议</h3>
<p>建议新读者先从免费章节开始，确认喜欢后再选择付费阅读。同时注意选择官方正版平台，支持作者的创作。</p>`,
    category: 'reading',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20and%20smartphone%20displaying%20webtoon%20reading%20interface%20on%20a%20cozy%20bedside%20table%2C%20warm%20evening%20lighting%2C%20comfortable%20reading%20environment%2C%20modern%20digital%20lifestyle%2C%20soft%20atmospheric%20photography&width=1200&height=675&seq=article-read-01&orientation=landscape',
    readTime: '7分钟',
    publishDate: '2026-07-25',
    tags: ['阅读平台', '在线阅读', '使用指南'],
  },
  {
    slug: 'art-style-appreciation',
    title: '继母的朋友们漫画画风赏析：从线条到分镜的艺术魅力',
    excerpt: '继母的朋友们漫画的画风是吸引读者的重要因素之一。本文将从专业角度分析本作的画风特点、分镜技巧和视觉美学。',
    content: `<p>《继母的朋友们》的画风在同类作品中独树一帜。作者在继承韩漫传统风格的基础上，融入了独特的个人印记。</p>
<h3>线条表现</h3>
<p>作者的线条运用相当成熟。人物轮廓的线条流畅而富有表现力，在关键情感场景中，线条的粗细变化能够准确传达角色的情绪状态。</p>
<h3>色彩运用</h3>
<p>色彩方面，本作以暖色调为主，营造出温馨而略带暧昧的氛围。在不同的场景中，色调的微妙变化能够很好地烘托剧情氛围。</p>
<h3>分镜设计</h3>
<p>分镜是本作的另一大亮点。作者善于运用各种分镜技巧来控制叙事节奏，无论是快速的动作场景还是细腻的情感交流，都有恰当的分镜处理。</p>`,
    category: 'reviews',
    coverImage: 'https://readdy.ai/api/search-image?query=Art%20supplies%20and%20illustration%20tools%20on%20a%20warm%20minimalist%20workspace%2C%20creative%20studio%20atmosphere%2C%20soft%20natural%20light%2C%20artistic%20process%20documentation%2C%20warm%20wood%20tones%2C%20editorial%20style&width=1200&height=675&seq=article-rev-02&orientation=landscape',
    readTime: '11分钟',
    publishDate: '2026-07-22',
    tags: ['画风赏析', '分镜分析', '艺术风格'],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((article) => article.slug === slug);
};

export const getFeaturedArticles = () => {
  return articles.slice(0, 6);
};

export const getRelatedArticles = (currentSlug: string, category: string) => {
  return articles
    .filter((article) => article.slug !== currentSlug && article.category === category)
    .slice(0, 3);
};